import { UnaryFunction, identity } from '@kofno/piper';
import { cond } from '../Cond';

export function replaceWhen<T>(
  predicate: UnaryFunction<T, boolean>,
  replacer: UnaryFunction<T, T>,
): UnaryFunction<T, T> {
  return cond(predicate, replacer, identity);
}
